
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/WebAdmin",
      function () {
        return require("private-next-pages/WebAdmin/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/WebAdmin"])
      });
    }
  